import api from './api';

// Toplu profil fotoğrafı yükleme (2026-10-19). Fotoğrafın kendisi bu uçlara gitmez: eşleşen dosya presign ile
// doğrudan depoya (purpose=avatar) yüklenir, sunucu yalnız dosya adını eşler ve adresi çalışana bağlar.
export const matchEmployeePhotos = (fileNames) =>
  api.post('/v1/employee-photos/match', { fileNames });

export const applyEmployeePhotos = (items) =>
  api.post('/v1/employee-photos/apply', { items });
